import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';

export interface Breadcrumb {
  title: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: Breadcrumb[];
  className?: string;
}

export function Breadcrumbs({ items, className }: BreadcrumbsProps) {
  return (
    <nav className={cn("flex", className)} aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="h-4 w-4 text-muted-foreground dark:text-muted-foreground mx-2" />
              )}
              {!isLast && item.href ? (
                <Link
                  to={item.href}
                  className="text-sm font-medium text-muted-foreground hover:text-foreground dark:text-muted-foreground dark:hover:text-muted-foreground"
                >
                  {item.title}
                </Link>
              ) : (
                <span className="text-sm font-medium text-brand-dark dark:text-foreground">
                  {item.title}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
} 